<template>
  <div>
    <work-order-list
      :display-create-button="true"
      :project-code="$route.params.projectCode"
      />
  </div>
</template>

<script>
import WorkOrderList from '@/components/pages/Admin/WorkOrders/WorkOrderList'

export default {
  components: {
    WorkOrderList
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Admin/Projects/ProjectWorkOrdersPage.vue